import { PureComponent } from 'react';

import { isNonNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';
import OverviewPropTypes from '../../../../OverviewPropTypes';
import menuTreeToMap from '../menuTreeToMap';
import FoundReportItem from './FoundReportItem';
import Leaf from './Leaf';
import clearTree from './clearTree';
import findResults from './findResults';

let debounce = null;

export default class TreeView extends PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
    fixedHeight: PropTypes.bool,
    msg: PropTypes.object.isRequired,
    onSelectReport: PropTypes.func.isRequired,
    onSelectReportAddToGroup: PropTypes.func,
    preselectReport: PropTypes.string,
    reportsGroups: OverviewPropTypes.reportsGroups,
    reportsMap: OverviewPropTypes.reportsMap,
    reportsList: PropTypes.object.isRequired,
    selectedGroup: OverviewPropTypes.selectedGroup,
    selectedReport: OverviewPropTypes.selectedReport,
    reportsInGroup: OverviewPropTypes.reportsInGroup,
  };

  static defaultProps = {
    fixedHeight: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      search: '',
      query: '',
      preselectReport: props.preselectReport,
    };
  }

  getReport = (id) => {
    const { reportsMap } = this.props;
    return reportsMap[id];
  };

  getResultsList = (clearedData, foundResults) => {
    const {
      msg,
      selectedGroup,
      selectedReport,
      reportsGroups,
      onSelectReport,
      onSelectReportAddToGroup,
      reportsInGroup,
    } = this.props;
    const treeMap = menuTreeToMap(clearedData, {}, []);
    return (
      <div>
        <div className='dashboard-color-form__tree-view-border-found-report-title'>
          {get(msg, ['dialog', 'groupSummary', 'colorRule'])}
        </div>
        {Object.keys(foundResults).reduce((acc, path) => {
          const pathResults = foundResults[path];
          return pathResults.reduce((pathAcc, result) => {
            const report = this.getReport(result);
            if (!report) {
              return pathAcc;
            }
            return pathAcc.concat(
              <FoundReportItem
                key={result}
                report={report}
                path={treeMap[path]
                  .filter((v) => isNonNullable(v) && v !== '')
                  .join(' > ')}
                selectedGroup={selectedGroup}
                selected={selectedReport === report.id}
                reportsGroups={reportsGroups}
                onSelectReport={onSelectReport}
                onSelectReportAddToGroup={onSelectReportAddToGroup}
                reportsInGroup={reportsInGroup}
              />,
            );
          }, acc);
        }, [])}
      </div>
    );
  };

  handleSearchChange = handleEvent(({ target: { value } }) => {
    this.setState({ search: value, preselectReport: null }, () => {
      if (debounce) {
        clearTimeout(debounce);
      }
      debounce = setTimeout(
        () => this.setState({ query: this.state.search }),
        500,
      );
    });
  });

  render() {
    const {
      data,
      fixedHeight,
      msg,
      onSelectReport,
      onSelectReportAddToGroup,
      reportsGroups,
      reportsInGroup,
      reportsList,
      selectedGroup,
      selectedReport,
    } = this.props;
    const { query, search, preselectReport } = this.state;
    const isQueryValid = query !== '' || isNonNullable(preselectReport);
    const clearedData = clearTree(data, query, reportsList);
    const foundResults = isQueryValid
      ? findResults(clearedData, query, {}, reportsList, preselectReport)
      : null;
    const resultsCount =
      (foundResults && Object.keys(foundResults).length) || 0;

    const getReportsContent = () => {
      if (isQueryValid) {
        if (resultsCount) {
          return this.getResultsList(clearedData, foundResults);
        }
        return (
          <div className='p-3'>
            {get(msg, ['dialog', 'groupSummary', 'noRuleFound'])}
          </div>
        );
      }
      if (clearedData?.length) {
        return (
          <Leaf
            data={clearedData}
            foundResults={foundResults}
            level={0}
            onSelectReport={onSelectReport}
            onSelectReportAddToGroup={onSelectReportAddToGroup}
            preselectReport={preselectReport}
            query={isQueryValid ? query : null}
            reportsGroups={reportsGroups}
            reportsList={reportsList}
            selectedGroup={selectedGroup}
            selectedReport={selectedReport}
            reportsInGroup={reportsInGroup}
          />
        );
      }
      return (
        <div className='p-3'>
          {get(msg, ['dialog', 'groupSummary', 'noRuleDefined'])}
        </div>
      );
    };

    return (
      <div
        className={classNames(
          'dashboard-color-form__tree-view-wrapper',
          fixedHeight &&
            'dashboard-color-form__tree-view-wrapper--fixed-height',
        )}
      >
        <h4>{get(msg, ['dialog', 'groupSummary', 'tableColorsRules'])}</h4>
        <div className='form-group'>
          <input
            id='addNewWidgetTreeSearch'
            className={classNames(
              'form-control',
              'dashboard-color-form__tree-view-search-input',
              search &&
                'dashboard-color-form__tree-view-search-input--magnifier',
            )}
            placeholder={get(msg, [
              'dialog',
              'groupSummary',
              'searchPlaceholder',
            ])}
            type='text'
            value={search}
            onChange={this.handleSearchChange}
          />
        </div>
        <div className='dashboard-color-form__tree-view-border-container'>
          {getReportsContent()}
        </div>
      </div>
    );
  }
}
